<mat-dialog-content>
  <div class="row" *ngIf="modal">
    <div class="col-md-6">
      <h2 class="titulo">{{ "COMPONENTS.METAS.topOperators.title" | transloco }}</h2>
    </div>
    <div class="col-md-6 d-flex justify-content-end">
      <button class="btn-expandir" (click)="fecharDialog()">
        <img src="../../../../../assets/metas/fechar-dialog.svg" alt="Expandir Resultados">
      </button>
    </div>
  </div>
  <table mat-table [dataSource]="dataSouce" class="mat-elevation-none">
    <tr *matNoDataRow>
        <td [attr.colspan]="displayedColumns.length" class="equipamento-vazio text-center text-muted">
            {{ "COMPONENTS.METAS.topOperators.noOperatorFound" | transloco }}
        </td>
    </tr>
    <ng-container matColumnDef="posicao">
        <th mat-header-cell *matHeaderCellDef> {{ "COMPONENTS.METAS.topOperators.columns.position" | transloco }} </th>
        <td mat-cell *matCellDef="let element"> 0{{element.posicao}} </td>
    </ng-container>

    <ng-container matColumnDef="vc_nome">
      <th mat-header-cell *matHeaderCellDef> {{ "COMPONENTS.METAS.topOperators.columns.name" | transloco }} </th>
      <td mat-cell *matCellDef="let element"> {{element.vc_nome}} </td>
    </ng-container>

    <ng-container matColumnDef="produtividade">
      <th mat-header-cell *matHeaderCellDef> {{ "COMPONENTS.METAS.topOperators.columns.productivity" | transloco }} </th>
      <td mat-cell *matCellDef="let element">
        <div class="barra-porcentagem-operador">
          <div class="barra-progresso" [style.background-color]="retornaCorOperadores('barra', element.posicao - 1)">
            <div class="barra-real" [style.width.%]="element.porcentagem" [style.background-color]="retornaCorOperadores('real', element.posicao - 1)"></div>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="porcentagem">
      <th mat-header-cell *matHeaderCellDef> {{ "COMPONENTS.METAS.topOperators.columns.percentage" | transloco }} </th>
      <td mat-cell *matCellDef="let element"> <span class="tabela-numeros"
        [style.border-color]="retornaCorOperadores('real', element.posicao - 1)"
        [style.color]="retornaCorOperadores('real', element.posicao - 1)"
        [style.background-color]="retornaCorOperadores('real', element.posicao - 1) + '15'">
        {{element.porcentagem}}
      </span> </td>
    </ng-container>

    <ng-container matColumnDef="total">
      <th mat-header-cell *matHeaderCellDef> {{ "COMPONENTS.METAS.topOperators.columns.ha" | transloco }} </th>
      <td mat-cell *matCellDef="let element"> <span class="tabela-numeros"
        [style.border-color]="retornaCorOperadores('real', element.posicao - 1)"
        [style.color]="retornaCorOperadores('real', element.posicao - 1)"
        [style.background-color]="retornaCorOperadores('real', element.posicao - 1) + '15'">
        {{element.total}}
      </span> </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</mat-dialog-content>

